import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  submit(event) {
    event.preventDefault();

    const form = this.formTarget;
    const formData = new FormData(form);
    const format = formData.get("format") || "csv";

    const url = form.action + `?format=${format}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        if (data.download_url) {
          if (format === "pdf") {
            window.open(data.download_url, "_blank");
          } else {
            window.location.href = data.download_url;
          }
        } else {
          alert("Export failed. Please try again.");
        }
      })
      .catch(() => {
        alert("An error occurred while exporting.");
      });
  }
}
